// =======================
// 🧠 React та хуки
// =======================
import { SetStateAction, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

// =======================
// 📦 Зовнішні бібліотеки
// =======================
import Table from "antd/lib/table";
import Spin from "antd/lib/spin";
import { Empty } from "antd";
import LoadingOutlined from "@ant-design/icons/LoadingOutlined";

// =======================
// 🌐 Контексти
// =======================
import { DatepickerContext } from "../../../contexts/datepicker/index.context";
import { ModalContext } from "../../../contexts/modal/index.context";
import { SessionContext } from "../../../contexts/session/index.context";
import { DrawerContext } from "../../../contexts/drawer/index.context";
import { TableContext } from "../../../contexts/table/index.context";
import { TranslationContext } from "../../../contexts/translation/index.context";

// =======================
// ⚙️ Сервіси / API
// =======================
import { request } from "../../../services";
// =======================
// 🧩 Утиліти / типи
// =======================
import { useTableColumns } from "./utils";
import {
  MergedColumnType,
  RowProcessorOptions,
  TableProps,
} from "./utils/types";
import { MergedTableStrType } from "../../../contexts/table/types";
import { FilterValue, SorterResult, TablePaginationConfig } from "antd/es/table/interface";
import { SessionFilters } from "../../../contexts/session/types";
import { table } from "console";

// =======================
// 🧱 Внутрішні компоненти
// =======================
import FloatButton from "../float-button";
// =======================
// 🎨 Стилі
// =======================
import styles from "./styles.module.scss";
import style2 from "./style2.module.scss";

export default function TableComponent(props: TableProps) {
  // console.log("PROPS URL TableComponent", props.url);
  let DrawerRowsIds = props.selectedRowsId;

  const location = useLocation();
  const { intl } = useContext(TranslationContext);
  const [tableData, setTableData] = useState<MergedColumnType[]>([]);
  const [reset, setReset] = useState(false);
  const [changeSelectedRowKeys, setChangeSelectedRowKeys] = useState<React.Key[]>(DrawerRowsIds ?? []);
  const modalContext = useContext(ModalContext);
  const { openModalFlag } = useContext(ModalContext)
  const datePickerContext = useContext(DatepickerContext);
  const {
    buttonStr,
    checkboxStr,
    boxStr,
    rowData,
    setRowData,
    numenclatureId,
    contextTableData,
    setContextTableData,
  } = useContext(TableContext);
  const { tableState, setTableState, sessionData, setSessionData, currentPageChange } =
    useContext(SessionContext);
  const [loading, setLoading] = useState(false);
  const [boxStrTable, setBoxStrTable] = useState<MergedTableStrType | undefined>(undefined);
  const drawerContext = useContext(DrawerContext);
  const { contentContext } = useContext(DrawerContext); //Використовується як флаг для відслідковування контента інпуту та очищення інпуту в формах з мультивибором в таблиці
  const propsUrl = props.url;
  
  const isDocuments = (props.url || location.pathname).split("/").slice(0, 2).join("/") === "/documents";
  const isListOfDocuments = propsUrl === "/documents/list-of-documents";
  const isPositions = propsUrl === "/directories/positions";
  const isEmployeesAndContacts =
    location.pathname === "/directories/employees-and-contact-persons";
  const isEmployeesAndContactsProp =
    propsUrl === "/directories/employees-and-contact-persons";
  const isNomenclatureOfCases =
    (propsUrl || location.pathname) === "/directories/nomenclature-of-cases";
  const isResolutionTemplates =
    (propsUrl || location.pathname) === "/directories/resolution-templates";
  const isExecutors =
    propsUrl === "/directories/resolution-templates/executors";
  const isTypesOfDocuments =
    (propsUrl || location.pathname) === "/directories/types-of-documents";
  const isStructuralUnits =
    (propsUrl || location.pathname) === "/directories/structural-units";
  const isDepartmentalJournals =
    (propsUrl || location.pathname) === "/directories/departmental-journals";
  const isElectronicMailOfDocuments =
    (propsUrl || location.pathname) === "/documents/electronic-mail";
  const isPassing = propsUrl === "/directories/passing";
  const isRelatedDocuments = propsUrl === "/directories/related-documents";
  const isDiscussion = propsUrl === "/directories/discussion";
  const isIncomingEmail = propsUrl === "/directories/incoming-email";
  const isGroupsOfCorrespondents =
    propsUrl === "/directories/groups-of-correspondents";
  const isTypesOfReceipts = propsUrl === "/directories/types-of-receipts";
  const isScroll =
    (!propsUrl && 
      location.pathname.split("/")[1].includes("documents")) ||
      location.pathname.split("/")[1].includes("directories") ||
    location.pathname === "/directories/nomenclature-of-cases-current" ||
    location.pathname === "/directories/employees" ||
    location.pathname === "/directories/structural-units" ||
    location.pathname === "/directories/departmental-journals";
  const tableRef = useRef(null);

  useEffect(() => {
    datePickerContext.setLoading(loading);
  }, [loading]);

    useEffect(() => {
    if(contentContext === undefined)
      DrawerRowsIds = [];
      setChangeSelectedRowKeys([]);
  }, [contentContext]);
  /**
   * Слідкує за зміною маршруту та очищає sessionStorage при переході на інший маршрут.
   */
  useEffect(() => {
    const previousRoute = sessionStorage.getItem("current_route");
    const currentRoute = location.pathname;
    sessionStorage.setItem("current_route", currentRoute);
    if (previousRoute && previousRoute !== currentRoute) {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith("session_data_") || key.startsWith("table_state_")) {
          sessionStorage.removeItem(key);
        }
      });
      setTableState({
        selectedRow: undefined,
        pageSize: 15,
        currentPage: 1,
      });
      setSessionData({});
    }
  }, [location]);

  // useEffect(() => {
  //   sessionStorage.setItem("table_state", JSON.stringify(tableState));
  // }, [tableState]);

  // useEffect(() => {
  //   if (props.tableData) {
  //     setTableData((prevTableData) => {
  //       const newData = [...prevTableData];
  //       props.tableData?.forEach((newRow) => {
  //         if (!newData.some((existingRow) => existingRow.id === newRow.id)) {
  //           newData.push(newRow);
  //         }
  //       });

  //       return newData;
  //     });
  //   }
  // }, [props.tableData]);
  
  /**
   * Визначаємо назву форми в залежності від того, чи є URL порожнім.
   * Якщо URL порожній, то використовуємо "main", інакше - "modal".
   */
  const formName = !props.url ? "main":"modal";

  useEffect(() => {
      // console.log("TABLE ID ", props.id);

    if (!isDocuments && !isIncomingEmail && modalContext.refresh) {
      const getBoxStr = boxStr.find((item) => item.url === (propsUrl || location.pathname) && item.formName === formName);  
      fetchDataTable(
        numenclatureId ?? props.id,
        `${getBoxStr?.buttonStr ?? ""} ${
          getBoxStr?.checkboxStr?.trim() || getBoxStr?.radioboxStr?.trim() || ""
        }`
      );
      modalContext.setRefresh(false);
    }
  }, [modalContext.refresh]);

  useEffect(() => {
    if (!isIncomingEmail && props.directories ) {
      const getBoxStr = boxStr.find((item) => item.url === (propsUrl || location.pathname) && item.formName === formName);
      // console.log("SORTER ", getBoxStr);

      // оновлення таблиці при зміні boxStr тільки на актуальній сторінці
      // Компонент керування зміною чекбоксів Довідники Загальні
      if ( getBoxStr != boxStrTable) {
        fetchDataTable(undefined, `${getBoxStr?.buttonStr ?? ""} ${getBoxStr?.checkboxStr?.trim() || getBoxStr?.radioboxStr?.trim() || ""}`);
        // propsUrl && 
        setBoxStrTable(getBoxStr);
      }
    }
  }, [boxStr]);
  
  useEffect(() => {
      setTableState((prevState) => ({ ...prevState, selectedRow: props.selectedRowId }));
      resolvedDataSource && currentPageChange(resolvedDataSource, props.selectedRowId);
  }, [drawerContext.open]);

  useEffect(() => {
      // console.log("props.directories ", props.directories);

    Object.keys(sessionData).length > 0 &&
      modalContext.setDisabled({ ...modalContext.disabled, edit: false });
      if (!isIncomingEmail && props.directories ) {
        const getBoxStr = boxStr?.find((item) => item.url === (propsUrl || location.pathname) && item.formName === formName);
         fetchDataTable(
          /* isExecutors && props.activeModal === "edit" ?  */ props.id /* : undefined */,
          `${getBoxStr?.buttonStr ?? ""} ${getBoxStr?.checkboxStr?.trim() || getBoxStr?.radioboxStr?.trim() || ""}`);
      }
  }, []);

  const fetchDataTable = async (id?: number, str?: string) => {
      if (isExecutors && !(typeof id === "number" && Number.isFinite(id))) {
    // опційно: очистити локальні дані списку
    setContextTableData([]);
    return;
  }
    // console.log("Using fetchDataTable function in TableComponent ", id);
    setLoading(true);
  const propsUrlRenamed = propsUrl === "/directories/outcoming-correspondents" ? "/directories/correspondents" : propsUrl;
    // console.log("NEWlist CHECKBOX FULL", str);

    datePickerContext.setLoading(true);
    const content = (
      await request(`${propsUrlRenamed ? propsUrlRenamed : location.pathname}/getdatatable`, {
        method:
          ((isEmployeesAndContacts || isResolutionTemplates) && !propsUrl) ||
          isExecutors ||
          isNomenclatureOfCases ||
          isEmployeesAndContactsProp ||
          isTypesOfDocuments ||
          isStructuralUnits ||
          isPassing ||
          isRelatedDocuments ||
          isDiscussion ||
          isDepartmentalJournals ||
          isGroupsOfCorrespondents ||
          isTypesOfReceipts
            ? "post"
            : "get",
        body:
          isEmployeesAndContacts ||
          isNomenclatureOfCases ||
          isEmployeesAndContactsProp ||
          isExecutors ||
          isTypesOfDocuments ||
          isStructuralUnits ||
          isPassing ||
          isRelatedDocuments ||
          isDiscussion ||
          isDepartmentalJournals ||
          isGroupsOfCorrespondents ||
          isTypesOfReceipts
            ? {
                id,
                str,
                type: props.type,
              }
            : undefined,
        cancelTokenKey: "getdatatable",
      })
    )?.content;
    const dataWithKeys =
      content?.map((item: any) => ({ ...item, key: item.id })) || [];
    isExecutors
      ? setContextTableData(dataWithKeys) // Треба для тимчасового зберігання даних у контексті
      : setTableData(dataWithKeys || []);
    // Якщо є вибраний рядок, встановлюємо його як поточний вибраний рядок, якщо передається `selectedRowId` з props то передавати інакше брати з tableState
    props.selectedRowId && currentPageChange(dataWithKeys, props.selectedRowId);
    datePickerContext.setLoading(false);
  };
    // console.log("Click on row in table  get", props.url);

      //   useEffect(() => {
       
      //  const Kontragents = FetchKontragents(location.pathname, sessionData.bta_documents_id);
      //   setKontragentsContext(Kontragents);
    
      // }, [RecordId]);

  const onClickRow = async (record: any) => {
    modalContext.setRecordId(record.id)
    console.log("Click on row in table ", record);

    // Закоментований код винесено в компонент модального вікна з поясненнями

    // let content;
    // if (isEmployeesAndContacts && !isPositions) {
    // console.log("Click on row in table  get1", props.url);
    //   content = (
    //     await request(`${location.pathname}/getdatatable`, {
    //       method: "post",
    //       body: { id: record.id },
    //       cancelTokenKey: "getdatatable",
    //     })
    //   )?.content;
    // }
    modalContext.setDisabled({ ...modalContext.disabled, edit: false });
    setTableState((prevState) => ({ ...prevState, selectedRow: record.id }));
    if (propsUrl) {
      const key = props.name
        ? `${propsUrl || location.pathname}/${props.name}`
        : propsUrl || location.pathname;
      const newTableData = {
        ...rowData,
        [key]: { id: record.id, data: record },
      };
      setRowData(newTableData);
    }
    // setSessionData(content?.[0] ?? record); Тут комент бо опрцювання в модалці
    setSessionData(record);
  };

  const handlePageSizeChange = (_current: number, size: number) => {
    setTableState((prevState) => ({ ...prevState, pageSize: size }));
  };

  const handleCurrentPageChange = (page: number) => {
    setTableState((prevState) => ({ ...prevState, currentPage: page }));
  };

  const handleOnChange = (pagination: TablePaginationConfig, filters: Record<string, FilterValue | null>, sorter: SorterResult<MergedColumnType> | SorterResult<MergedColumnType>[] ) => {
    const sort = (sorter as SorterResult<MergedColumnType>);
    const filtersArray = Object.entries(filters || {});
    setTableState({
      ...tableState,
      pageSize: pagination?.pageSize || tableState.pageSize,
      currentPage: pagination?.current || tableState.currentPage,
      filters: filtersArray && filtersArray.length > 0 ?
        filtersArray.reduce((acc:SessionFilters[], [key, value]) => {
          value && acc.push({ columnKey: key, columnValue: value, });
          return acc;
        }
        , [])
        : undefined,
      sorter: sort && sort.columnKey && sort.field && sort.order ? {
        columnKey: sort.columnKey,
        field:  sort.field,
        order:  sort.order,
      }: undefined,
    });
  }

  // const isSameFilters = (filtersArray: [string, FilterValue | null][] ) => {
  //   if (!tableState.filters || tableState.filters.length !== filtersArray.length) {
  //     return false;
  //   }
  
  //   return filtersArray.every(([key, value]) => {
  //     const oldFilter = tableState.filters!.find(f => f.columnKey === key);
  //     if (!oldFilter) return false;
  
  //     // Порівнюємо значення масивів (безпорядкове порівняння)
  //     const newVals = Array.isArray(value) ? value : [value];
  //     const oldVals = Array.isArray(oldFilter.columnValue) ? oldFilter.columnValue : [oldFilter.columnValue];
  
  //     if (newVals.length !== oldVals.length) return false;
  
  //     return newVals.every(v => oldVals.includes(v));
  //   });
  // };

  function processRows({
    data,
    removedKeys,
    existingIds,
    getRowKey,
    shouldInclude,
    mapRow,
  }: RowProcessorOptions): any[] {
    return data.reduce((acc: any[], row, index) => {
      if (!shouldInclude(row)) return acc;

      const key = getRowKey(row);
      if (key && existingIds.has(key)) return acc;

      if (key) existingIds.add(key);
      acc.push(mapRow(row, index, existingIds.size));
      return acc;
    }, []);
  }
const rowSelection = {
    selectedRowKeys: changeSelectedRowKeys,
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      const removedKeys = changeSelectedRowKeys.filter(
        (key) => !selectedRowKeys.includes(key)
      );

      const existingIds = new Set<string>();
      const fromContext = processRows({
        data: contextTableData ?? DrawerRowsIds ?? [],
        removedKeys,
        existingIds,
        getRowKey: (row) =>
          isEmployeesAndContactsProp
            ? row.clerksId
              ? `C${row.clerksId}`
              : row.sta_clerks_id
              ? `C${row.sta_clerks_id}`
              : row.contactPersonId
              ? `P${row.contactPersonId}`
              : row.sta_kont_lico_id
              ? `P${row.sta_kont_lico_id}`
              : null
            : row.id
            ? row.id
            : null,

        shouldInclude: (row) =>
          !(
            removedKeys &&
            row.selectedRowKeys &&
            removedKeys.includes(row.selectedRowKeys)
          ),

        mapRow: (row, index, totalCount) =>
          isEmployeesAndContactsProp
            ? {
                id: totalCount,
                key: totalCount,
                tableId: row.tableId === -1 ? -1 : row.tableId || row.id,
                num_pp: row.num_pp,
                ExecutorFIO: row.ExecutorFIO,
                clerksId: row.clerksId || row.sta_clerks_id,
                contactPersonId: row.contactPersonId || row.sta_kont_lico_id,
                resolutionId: sessionData.id,
                selectedRowKeys:
                  changeSelectedRowKeys.length == 0
                    ? null
                    : row.selectedRowKeys,
                url: propsUrl,
              }
            : {
                ...row,
                url: propsUrl,
                selectedRowKeys:
                  changeSelectedRowKeys.length == 0
                    ? null
                    : row.selectedRowKeys,
              },
      });

      const fromSelected = processRows({
        data: selectedRows,
        removedKeys,
        existingIds,
        getRowKey: (row) =>
          isEmployeesAndContactsProp
            ? row.sta_clerks_id
              ? `C${row.sta_clerks_id}`
              : row.sta_kont_lico_id
              ? `P${row.sta_kont_lico_id}`
              : null
            : row.id
            ? row.id
            : null,

        shouldInclude: (_) => true,

        mapRow: (row, index, totalCount) =>
          isEmployeesAndContactsProp
            ? {
                id: totalCount,
                key: totalCount,
                tableId: -1,
                num_pp: totalCount,
                ExecutorFIO: row.contact_person,
                clerksId: row.sta_clerks_id,
                contactPersonId: row.sta_kont_lico_id,
                resolutionId: sessionData.id,
                selectedRowKeys: selectedRowKeys[index],
                url: propsUrl,
              }
            : {
                ...row,
                url: propsUrl,
                selectedRowKeys: selectedRowKeys[index],
              },
      });

      const modifiedRows = [...fromContext, ...fromSelected];

      // 1. Сортуємо по num_pp
      const sortedRows = [...modifiedRows].sort((a, b) => a.num_pp - b.num_pp);

      // 2. (опційно) перевіряємо на унікальність num_pp, інакше — перенумеровуємо
      const renumberedRows = sortedRows.map((row, index) => ({
        ...row,
        num_pp: index + 1,
      }));

      setChangeSelectedRowKeys(selectedRowKeys);
      setContextTableData(renumberedRows);
    },
  };

  const newSelectTableData = [
    ...tableData,
    ...(props.tableData || []).map((item, index) => ({
      ...item,
      num_pp: tableData.length + index + 1,
    })),
  ];

  const isMainTable = !propsUrl;
  // propsUrl &&  console.log(tableData, "tableData 1", propsUrl);
  // !propsUrl && location.pathname && console.log(tableData, "tableData 2", location.pathname);
 // propsUrl &&  console.log(datePickerContext?.tableDataValue, "datePickerContext?.tableDataValue propsUrl", propsUrl);
  // !propsUrl && location.pathname && console.log(datePickerContext?.tableDataValue, "datePickerContext?.tableDataValue location.pathname", location.pathname);
  const resolvedDataSource =
    props.tableData && props.tableData.length > 0
      ? newSelectTableData
      : tableData.length > 0
      ? tableData
      : isMainTable || isIncomingEmail || isListOfDocuments
      ? datePickerContext?.tableDataValue?.find(
          (item: any) => item.url === (propsUrl || location.pathname)
        )?.tableData || []
      : [];

  // console.log(props.tableData, "props.tableData");
  // console.log("TableComponent ===== newSelectTableData", newSelectTableData);
  // console.log("ACTIVEMODAL ", openModalFlag, " url ", propsUrl);
  // console.log(isMainTable, "isMainTable");
  // console.log(isIncomingEmail, "isIncomingEmail");
  // console.log(datePickerContext?.tableDataValue, "datePickerContext.tableData");

  // const containerClassName = isElectronicMailOfDocuments
  //   ? styles["table-container2"]
  //   : props.url === undefined
  //   ? styles["table-container"]
  //   : style2["table-container"];

  const passing = propsUrl === "/directories/passing";
  const employeeAndContact = propsUrl === "/directories/employees-and-contact-persons";
  const employeeAndContactURL = location.pathname === "/directories/employees-and-contact-persons";
  const employees = propsUrl === "/directories/employees";
  const structural = propsUrl === "/directories/structural-units";
  const typeDocuments = propsUrl === "/directories/types-of-documents";
  const relatedDocuments = propsUrl === "/directories/related-documents";
  const discussions = propsUrl === "/directories/discussion";
  const resolTemplates = propsUrl === "/directories/resolution-templates/executors";
 


  const height = useMemo(() => {
  if (isElectronicMailOfDocuments) return 'calc(100vh - 420px)';
  if (passing) return '450px';
  if (employeeAndContact) return 'calc(93vh - 130px)';
  if (employeeAndContactURL) return 'calc(98vh - 140px)';
  if (employees) return 'calc(99vh - 130px)';
  if (structural) return 'calc(96vh - 130px)';
  if (typeDocuments) return 'calc(97vh - 130px)';
  if (relatedDocuments) return '450px';
  if (discussions) return '450px';
  if (resolTemplates) return '500px';


  return 'calc(98vh - 110px)';
}, [isElectronicMailOfDocuments, employeeAndContact, passing, employees, relatedDocuments, structural, typeDocuments, discussions, resolTemplates, employeeAndContactURL]);


 const scroll = useMemo(() => {
  if (isElectronicMailOfDocuments) return 'calc(100vh - 420px)';
  if (passing) return '450px';
  if (employeeAndContact) return 'calc(93vh - 130px)';
  if (employeeAndContactURL) return 'calc(98vh - 140px)';
  if (employees) return 'calc(99vh - 130px)';
  if (structural) return 'calc(96vh - 130px)';
  if (typeDocuments) return 'calc(97vh - 130px)';
  if (relatedDocuments) return '450px';
  if (discussions) return '450px';
  if (resolTemplates) return '500px';


  return 'calc(98vh - 110px)';
}, [isElectronicMailOfDocuments, employeeAndContact, passing, employees, relatedDocuments, structural, typeDocuments, discussions, resolTemplates, employeeAndContactURL]);


  return (
    // <div ref={tableRef} className={containerClassName}>
    <div ref={tableRef}>
      <Table
      showSorterTooltip={{ title: intl("sort-title") }}
      tableLayout="fixed"
        className={styles["table"]}
        // className={props.url === undefined ? styles["table"] : style2["table"]}

        // key={reset ? "reset" : "not-reset"}
        columns={useTableColumns(reset, setReset, propsUrl, tableData)}
        dataSource={resolvedDataSource}
        onChange={(_, filters, sorter) => handleOnChange(_, filters, sorter)}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={intl("no-data")}
            />
          ),
        filterConfirm: "OK",          // текст на кнопці OK
        filterReset: intl("reset"),
        }}
        onRow={(record, index) => ({
          onClick: () => {
            onClickRow(record);
          },
        })}
        rowClassName={(record, index) => {
          return record.id === tableState.selectedRow
            ? styles["selected-row"]
            : "";
        }}
        rowSelection={
          props.allowMultiSelect ? rowSelection : undefined}
        pagination={
          isPassing || isDiscussion || isRelatedDocuments
            ? false
            : {
                position: ["bottomCenter"],
                pageSize: tableState.pageSize || 15,
                pageSizeOptions: [15, 20, 50, 100],
                showSizeChanger: true,
                onShowSizeChange: handlePageSizeChange,
                current: tableState.currentPage,
                onChange: (page) => handleCurrentPageChange(page),
                locale: {
                  items_per_page: intl("selector-page"),
                },
              }
        }

        style={{height: `${height}`}}

        scroll={{ x: "fixed", y: `${scroll}` }}

        // style={{height: `${isElectronicMailOfDocuments ? "calc(100vh - 380px)" : `${isEmployeesAndContacts ? "calc(100vh - 150px)" : `${isShort ? "calc(100%)" : "calc(100vh - 120px)"}`}`}`}}
        // scroll={
        //   isScroll
        //     ? {
        //         x: "max-content",
        //         y: isElectronicMailOfDocuments
        //           ? "calc(100vh - 380px)"
        //           : isEmployeesAndContacts ? "calc(100vh - 150px)" : `${isShort ? "calc(100%)" : "calc(100vh - 120px)"}`,
        //       }
        //     : undefined
        // }
        sticky={false}
        loading={{
          spinning: datePickerContext.loading,
          indicator: (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
          ),
        }}
        size="small"
        // bordered
      />
      <FloatButton tableRef={tableRef} />
    </div>
  );
}
